export default "__VITE_ASSET__ccc4a4a4__"